import { MenuItem } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { Select, SelectProps } from '~components';
import i18n from '~lib/i18n';

import PaymentStatusEnum from '../../enums/paymentStatusEnum';

const PaymentStatusSelect = ({
	emptyLabel = i18n.t('ui.filter.status.all'),
	...selectProps
}: SelectProps) => {
	const { t } = useTranslation();

	return (
		<Select {...selectProps} emptyLabel={emptyLabel}>
			{Object.values(PaymentStatusEnum).map((el: PaymentStatusEnum) => (
				<MenuItem key={el} value={el}>
					{t(`ui.status.${el === PaymentStatusEnum.Canceled ? 'cancelled' : el}`)}
				</MenuItem>
			))}
		</Select>
	);
};

export default PaymentStatusSelect;
